var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuery = function SvgQuery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71757A",
    fillRule: "evenodd",
    d: "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m5 2.5A.5.5 0 0 1 6 8h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5m-.047-4.364a1 1 0 0 1 1.507.863V5c0 .235-.183.48-.527.709a3 3 0 0 1-.624.314l-.008.003a.5.5 0 0 0 .317.948L5.96 6.5l.159.474h.002l.006-.003.017-.006a3 3 0 0 0 .253-.102c.158-.07.373-.177.59-.322.405-.27.973-.775.973-1.54a2 2 0 0 0-3.887-.667.5.5 0 1 0 .944.332 1 1 0 0 1 .436-.53",
    clipRule: "evenodd"
  })));
};
export default SvgQuery;